var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPricetag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3333 12.7311C12.0697 12.7311 12.6667 12.1342 12.6667 11.3978C12.6667 10.6614 12.0697 10.0645 11.3333 10.0645C10.597 10.0645 10 10.6614 10 11.3978C10 12.1342 10.597 12.7311 11.3333 12.7311Z",
    fill: "black",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.33203 9.39844V14.5438C5.33203 15.2598 5.61603 15.9464 6.1227 16.4531L16.944 27.2744C17.1948 27.5252 17.4924 27.7241 17.82 27.8598C18.1476 27.9955 18.4988 28.0654 18.8534 28.0654C19.208 28.0654 19.5591 27.9955 19.8867 27.8598C20.2143 27.7241 20.512 27.5252 20.7627 27.2744L27.208 20.8291C27.4588 20.5784 27.6577 20.2807 27.7934 19.9531C27.9291 19.6255 27.999 19.2744 27.999 18.9198C27.999 18.5652 27.9291 18.214 27.7934 17.8864C27.6577 17.5588 27.4588 17.2612 27.208 17.0104L16.3854 6.1891C15.8793 5.6831 15.193 5.39871 14.4774 5.39844H9.33203C8.27117 5.39844 7.25375 5.81987 6.5036 6.57001C5.75346 7.32016 5.33203 8.33757 5.33203 9.39844V9.39844Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricetag);
export default __webpack_public_path__ + "static/media/pricetag.b0891aba39ac01abf40168597a17a2a2.svg";
export { ForwardRef as ReactComponent };